<fl-modal
  [actionDisabled]="!verificationIsValid"
  [actions]="modalActions"
  [modalTitle]="data.title"
>
  <fl-message-box
    *ngIf="data.infoMessage && data.position === 'top'"
    [type]="data.destructive ? messageBoxType.Alert : messageBoxType.Info"
    [messages]="[data.infoMessage]"
  ></fl-message-box>

  <p [innerHTML]="data.message"></p>

  <ng-container *ngIf="data.verificationString">
    <p>
      Please type <b>{{ data.verificationString }}</b> to confirm.
    </p>
    <mat-form-field appearance="outline" floatLabel="always">
      <input
        [(ngModel)]="userInputForVerification"
        matInput
        type="text"
      />
    </mat-form-field>
  </ng-container>

  <fl-message-box
    *ngIf="data.infoMessage && data.position === 'bottom'"
    [type]="data.destructive ? messageBoxType.Alert : messageBoxType.Info"
    [messages]="[data.infoMessage]"
  ></fl-message-box>
</fl-modal>
